import type { NavigateFunction } from 'react-router-dom';
import { resolveIndexerPagePath } from './indexer-paths';
import {
  INSPECT_WEBHOOK_URL_STATUS_CHANGED,
  WEBHOOK_BUCKET_IDS,
} from './inspect-webhook-events';

export interface InspectScheduleCreatePrefill {
  urls: string[];
  webhookEvents: string[];
  webhookFilters: string[];
  autoIndexNotIndexed?: boolean;
  name?: string;
}

export type InspectPageLocationState = {
  prefillUrls?: string[];
  prefillSource?: string;
  schedulePrefill?: InspectScheduleCreatePrefill;
};

export function buildStatusChangeSchedulePrefill(
  urls: string[],
): InspectScheduleCreatePrefill {
  return {
    urls,
    name: 'زمان‌بندی جدید',
    webhookEvents: [INSPECT_WEBHOOK_URL_STATUS_CHANGED],
    webhookFilters: [...WEBHOOK_BUCKET_IDS],
  };
}

export function navigateToStatusChangeSchedule(
  navigate: NavigateFunction,
  urls: string[],
  source: string,
  path?: string,
) {
  navigate(resolveIndexerPagePath('url-inspection', path), {
    state: {
      prefillSource: source,
      schedulePrefill: buildStatusChangeSchedulePrefill(urls),
    },
  });
}
